function elementsToMaxHeight(elements)
{
  console.log('test');
  let height = 1
  elements.each(function (){
    let thisHeight = $(this).outerHeight()
    height = thisHeight > height ? thisHeight : height
  })

  elements.css('height', `${height}px`)
}

function elementsToMaxWidth(elements)
{
  let width = 1
  elements.each(function (){
    let thisWidth = $(this).width()
    width = thisWidth > width ? thisWidth : width
  })

  elements.css('width', `${width}px`)
}

export { elementsToMaxHeight, elementsToMaxWidth }
